export default __webpack_public_path__ + "fonts/slick.ttf?c94f7671dcc99dce43e22a89f486f7c2";